// tslint:disable file-name-casing
import 'custom-event-polyfill';
// Installs a global setImmediate. Webpack got this transitively via the
// `setimmediate` package's side-effect; Rolldown does not guarantee that, and
// both app code (useOverlayScrollLock) and bundled libs (exceljs, draft-js,
// pdfmake) call the global.
import 'setimmediate';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import React from 'react';
import * as ReactDOMLegacy from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxQueryProvider } from 'redux-query-react';
import configureStore from './helpers/reduxStore';
import LocaleRouter from './routers/LocaleRouter';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from './common/styles/theme/default';

// React 19 removes react-dom.findDOMNode; patch a no-op for legacy libs
// that still call it at runtime (e.g. older transition stacks).
const patchFindDomNode = (target: unknown) => {
  const typedTarget = target as { findDOMNode?: (instance: unknown) => Element | Text | null } | undefined;
  if (!typedTarget || typeof typedTarget.findDOMNode === 'function') {
    return;
  }
  try {
    Object.defineProperty(typedTarget, 'findDOMNode', {
      value: () => null,
      writable: true,
      configurable: true,
    });
  } catch {
    // Ignore immutable module export shapes.
  }
};

patchFindDomNode(ReactDOMLegacy);
patchFindDomNode((ReactDOMLegacy as { default?: unknown }).default);

const msalInstance = new PublicClientApplication(msalConfig);
const rootEl = document.getElementById('root');
export const store = configureStore();

if (document.documentElement) {
  document.documentElement.classList.remove('is-loading');
}

const root = createRoot(rootEl!);
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <ReduxQueryProvider queriesSelector={(state) => state.queries}>
        <ThemeProvider theme={defaultTheme}>
          <BrowserRouter>
            <LocaleRouter />
          </BrowserRouter>
        </ThemeProvider>
      </ReduxQueryProvider>
    </Provider>
  </MsalProvider>
);
